import './page-nav.scss';

import { Breadcrumb, Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { LeftOutlined } from '@/media/antd-icons';

import { LocalizedLink } from '../localized-link';

export interface IPageNavItem {
  title: string;
  /** Путь из `ROUTES`; у текущего экрана (последней крошки) его нет. */
  to?: string;
}

interface IProps {
  items: IPageNavItem[];
  onBack: () => void;
}

/**
 * Навигация экрана записи на широком экране: хлебные крошки и «Назад», как в лизинговом
 * кабинете. Прячется вместе с заголовком страницы, когда «назад» показывает шапка каркаса.
 */
const PageNav: React.FC<IProps> = ({ items, onBack }) => {
  const { t } = useTranslation();

  return (
    <nav className="page-nav" aria-label={t('layout.breadcrumbs')}>
      <Breadcrumb
        items={items.map(({ title, to }) => ({
          title: to ? <LocalizedLink to={to}>{title}</LocalizedLink> : title
        }))}
      />
      <Button
        type="text"
        className="page-nav__back"
        icon={<LeftOutlined />}
        onClick={onBack}
      >
        {t('common.back')}
      </Button>
    </nav>
  );
};

export default PageNav;
